'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Local dependencies
 */
var _require = require('jose'),
    JWT = _require.JWT;

var IDTokenSchema = require('./IDTokenSchema');

/**
 * IDToken
 */

var IDToken = function (_JWT) {
  _inherits(IDToken, _JWT);

  function IDToken() {
    _classCallCheck(this, IDToken);

    return _possibleConstructorReturn(this, (IDToken.__proto__ || Object.getPrototypeOf(IDToken)).apply(this, arguments));
  }

  _createClass(IDToken, null, [{
    key: 'schema',


    /**
     * Schema
     */
    get: function get() {
      return IDTokenSchema;
    }
  }]);

  return IDToken;
}(JWT);

/**
 * Export
 */


module.exports = IDToken;


//////////////////
// WEBPACK FOOTER
// ../solid-auth-oidc/~/oidc-rp/lib/IDToken.js
// module id = 136
// module chunks = 0